import React from 'react';
import { Card, Accordion } from 'react-bootstrap';
import { DebounceInput } from "react-debounce-input";
import { NumToFa} from "../../Functions/TextTransform";
import NumberToPersianWord from "number_to_persian_word";


export default function Step5DTrackPleated({
 step3, step31, step3ATrack, step3ARod1, depSet, accordionActiveKey, t, stepSelectedLabel, requiredStep, setCart, setCartLoading, setDeps, optionSelectChanged, selectChanged, pageLanguage, NextStep, ContextAwareToggle,step3A0 ,ceilingToFloor, setCeilingToFloor, heightCart
}) {
  return (
   <Card
   className={
     step3 === "true" &&
     step31 === "Track" &&
     ((step3ATrack !== "" && step3ATrack !== "Apron") ||
       (step3ATrack === "Apron" && step3ARod1 === "true"))
       ? ""
       : "noDisplay"
   }
 >
   <Card.Header
     className={
       [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
       !accordionActiveKey.startsWith("3")
         ? "hidden"
         : ""
     }
   >
     <ContextAwareToggle
       eventKey="3D"
       stepNum={t("5D")}
       stepTitle={t("dk_step2FWall2")}
       stepRef="3DRod"
       type="2"
       required={requiredStep["3DRod"]}
       stepSelected={
         stepSelectedLabel["3DRod"] === undefined ? "" : stepSelectedLabel["3DRod"]
       }
     />
   </Card.Header>
   <Accordion.Collapse eventKey="3D">
     <Card.Body>
       <div className="card_body">
         <div className="box100">
           <p className="step_selection_title">{t("dk_step2GWall_title")}</p>
           <img
             src={
               pageLanguage === "fa"
                 ? step3A0 === "Moulding"
                   ? require("../../Images/drapery/europeanNew2/FMouldingTrack-Home01.svg").default
                   : require("../../Images/drapery/europeanNew2/Ftrackroomheight.svg").default
                 : step3A0 === "Moulding"
                 ? require("../../Images/drapery/europeanNew2/MouldingTrack-Home01.svg").default
                 : require("../../Images/drapery/europeanNew2/trackroomheight.svg").default
             }
             className="img-fluid frame_with_top2 55"
             alt=""
           />
         </div>
         <div className="box100 Three_selection_container">
           <div className="box100">
             <div className="measure_input_container">
               <div className="measure_input_field_container">
                 <DebounceInput
                   debounceTimeout={1500}
                   autoComplete="off"
                   onKeyDown={(e) => {
                     if (
                       !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                       e.keyCode !== 8 &&
                       e.keyCode !== 46 &&
                       e.keyCode !== 37 &&
                       e.keyCode !== 39 &&
                       e.keyCode !== 13
                     ) {
                       e.preventDefault();
                     }
                   }}
                   className={
                     "measure_input" +
                     (ceilingToFloor !== undefined &&
                     (ceilingToFloor < 1 ||
                       ceilingToFloor > 1000 ||
                       (heightCart && ceilingToFloor < +heightCart))
                       ? " measure_input_err"
                       : "")
                   }
                   type="text"
                   name="ceilingToFloor"
                   value={NumToFa(`${ceilingToFloor || ""}`, pageLanguage)}
                   onChange={(e) => {
                     setTimeout(() => {
                       let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                       newValue = isNaN(newValue) ? "" : newValue;
                       if (
                         newValue &&
                         newValue !== "" &&
                         parseInt(newValue) >= 1 &&
                         parseInt(newValue) <= 1000 &&
                         !(heightCart && parseInt(newValue) < +heightCart)
                       ) {
                         setCartLoading(true);
                         setCart("CeilingToFloor", parseInt(newValue));
                         setDeps("", "3DRod");
                         setCeilingToFloor(parseInt(newValue));
                         optionSelectChanged(
                           "3DRod",
                           parseInt(newValue),
                           "cm",
                           "س\u200Cم",
                           pageLanguage
                         );
                       } else {
                         setCartLoading(true);
                         setCart("", "", "CeilingToFloor");
                         setDeps("3DRod", "");
                         if (newValue === "" || isNaN(parseInt(newValue))) {
                           setCeilingToFloor(undefined);
                           selectChanged(undefined, "3DRod");
                         } else {
                           setCeilingToFloor(parseInt(newValue));
                           selectChanged("3DRod", undefined, t("Invalid Measurements"));
                         }
                       }
                     }, 300);
                   }}
                 />
                 <div className="measure_input_postfix">{t("cm_label")}</div>
               </div>
               <h2
                 className={
                   "measure_input_desc" +
                   (ceilingToFloor !== undefined &&
                   (ceilingToFloor < 1 ||
                     ceilingToFloor > 1000 ||
                     (heightCart && ceilingToFloor < +heightCart))
                     ? " measure_input_desc_err"
                     : "")
                 }
               >
                 {heightCart && ceilingToFloor < +heightCart
                   ? t("roomHeight_more_than_height")
                   : ""}
               </h2>
             </div>
           </div>
         </div>
         <NextStep
           currentStep={
             [...depSet].findIndex((el) => el.startsWith("3")) === -1 ? "3" : "3DRod"
           }
           eventKey="4"
         >
           {t("NEXT STEP")}
         </NextStep>
       </div>
   
     </Card.Body>
   </Accordion.Collapse>
 </Card>
  )
}
